import React from "react"
import { MobergFontFamily } from "../../../../Moberg"

export const AvailableDataSourceHint: React.FC = () => (
	<div style={{
		display: "inline-flex",
		alignItems: "center",
		fontSize: 12,
		color: "var(--text-secondary-color)",
		fontFamily: MobergFontFamily.REGULAR,
		background: "var(--color-hover-neutral)",
		borderRadius: 4,
		padding: "6px 10px",
		width: "fit-content",
	}}>
		<span style={{
			display: "inline-block",
			width: 8,
			height: 8,
			borderRadius: "50%",
			background: "var(--color-accent-interactive)",
			marginRight: 8,
			flexShrink: 0,
		}} />
		<span>Blue dot denotes available data source in the selected patient file</span>
	</div>
)
